import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

export const DisclaimerFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      className="fixed bottom-0 left-0 right-0 z-40 bg-slate-900/95 backdrop-blur-sm border-t border-slate-700 safe-bottom"
      data-testid="disclaimer-footer"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-1.5 sm:py-2">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs">
          {/* Disclaimer Text */}
          <div className="flex items-center gap-2 text-slate-400">
            <AlertTriangle className="h-3.5 w-3.5 text-amber-500 flex-shrink-0" />
            <span className="text-center sm:text-left">
              <strong className="text-amber-400">Educational purposes only.</strong>
              {' '}Not financial advice. Options trading involves risk. 
              <span className="hidden sm:inline"> Use at your own risk.</span>
            </span>
          </div>
          
          {/* Links & Copyright */}
          <div className="flex items-center gap-3 text-slate-500">
            <button 
              onClick={() => {
                localStorage.removeItem('ofs_disclaimer_accepted');
                window.location.reload();
              }}
              className="hover:text-slate-300 transition-colors underline underline-offset-2"
              data-testid="view-full-disclaimer-link"
            >
              Disclaimer
            </button>
            <span>|</span>
            <button 
              onClick={() => navigate('/legal')}
              className="hover:text-slate-300 transition-colors underline underline-offset-2"
              data-testid="legal-center-link"
            >
              Legal Center
            </button>
            <span>|</span>
            <button 
              onClick={() => navigate('/terms')}
              className="hover:text-slate-300 transition-colors underline underline-offset-2"
              data-testid="terms-of-service-link"
            >
              Terms of Service
            </button>
            <span className="hidden sm:inline">|</span>
            <span className="hidden sm:inline">© {currentYear} Option Wizard</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DisclaimerFooter;
